const initialState = {

    //organisation data
    loadingOrganisationsData: false,
    OrganisationsDataError: '',
    OrganisationsData: [],


    //orgnaisation branch
    loadingOrganisationBranchData: false,
    OrganisationBranchDataError: '',
    OrganisationBranchData: [],

    //tradeinvoice rcm
    loadingTradeInvoiceRCMList: false,
    TradeInvoiceRCMList: [],
    TradeInvoiceRCMListError: '',
    TradeInvoiceRCMListCurrentPage: 0,
    TradeInvoiceRCMListTotalPage: 0,
    TradeInvoiceRCMListTotalData: 0,


    //rcm view
    loadingTradeInvoiceRCMView: false,
    TradeInvoiceRCMView: {},
    TradeInvoiceRCMViewError: '',

}

const TradeInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {

        //organisation data details//
        case 'FIND_TRADE_INVOICE_ORGANISATIONS_REQUEST':
            return {
                ...state,
                loadingOrganisationsData: true,
                OrganisationsDataError: '',
                OrganisationsData: [],
            };
        case 'FIND_TRADE_INVOICE_ORGANISATIONS_SUCCESS':
            return {
                ...state,
                loadingOrganisationsData: false,
                OrganisationsDataError: '',
                OrganisationsData: action.payload,
            };
        case 'FIND_TRADE_INVOICE_ORGANISATIONS_FAILURE':
            return {
                ...state,
                loadingOrganisationsData: false,
                OrganisationsDataError: action.payload,
                OrganisationsData: [],
            };
        //organisation data details//
        //organisation branch data details//
        case 'FIND_TRADE_INVOICE_ORGANISATION_BRANCH_REQUEST':
            return {
                ...state,
                loadingOrganisationBranchData: true,
                OrganisationBranchDataError: '',
                OrganisationBranchData: [],
            };
        case 'FIND_TRADE_INVOICE_ORGANISATION_BRANCH_SUCCESS':
            return {
                ...state,
                loadingOrganisationBranchData: false,
                OrganisationBranchDataError: '',
                OrganisationBranchData: action.payload,
            };
        case 'FIND_TRADE_INVOICE_ORGANISATION_BRANCH_FAILURE':
            return {
                ...state,
                loadingOrganisationBranchData: false,
                OrganisationBranchDataError: action.payload,
                OrganisationBranchData: [],
            };
        //organisation branch data details//




        //tradeinvoice rcm
        case 'FIND_TRADE_INVOICE_RCM_REQUEST':
            return {
                ...state,
                loadingTradeInvoiceRCMList: true,
                TradeInvoiceRCMList: [],
                TradeInvoiceRCMListError: '',
                TradeInvoiceRCMListCurrentPage: 0,
                TradeInvoiceRCMListTotalPage: 0,
                TradeInvoiceRCMListTotalData: 0,
            };
        case 'FIND_TRADE_INVOICE_RCM_SUCCESS':
            return {
                ...state,
                loadingTradeInvoiceRCMList: false,
                TradeInvoiceRCMList: action.payload.data,
                TradeInvoiceRCMListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                TradeInvoiceRCMListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                TradeInvoiceRCMListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_TRADE_INVOICE_RCM_FAILURE':
            return {
                ...state,
                loadingTradeInvoiceRCMList: false,
                TradeInvoiceRCMList: [],
                TradeInvoiceRCMListError: action.payload,
                TradeInvoiceRCMListCurrentPage: 1,
                TradeInvoiceRCMListTotalPage: 0,
                TradeInvoiceRCMListTotalData: 0,
            };
        //tradeinvoice rcm

        //rcm view
        case 'FIND_TRADE_INVOICE_RCM_VIEW_REQUEST':
            return {
                ...state,
                loadingTradeInvoiceRCMView: true,
                TradeInvoiceRCMView: {},
                TradeInvoiceRCMViewError: '',

            };
        case 'FIND_TRADE_INVOICE_RCM_VIEW_SUCCESS':
            return {
                ...state,
                loadingTradeInvoiceRCMView: false,
                TradeInvoiceRCMView: action.payload.data,

            };
        case 'FIND_TRADE_INVOICE_RCM_VIEW_FAILURE':
            return {
                ...state,
                loadingTradeInvoiceRCMView: false,
                TradeInvoiceRCMView: {},
                TradeInvoiceRCMViewError: action.payload,

            };
        //rcm view

        default:
            return state;
    }
}

export default TradeInvoiceReducer;